<template>
	<div class='story'>
		<Kaart :data="data" />
<!-- 		<Barcode title="Energiearmoede" :data="energieArmoede" />

		<Barcode title="Woningcorperatiebezit" :data="woningcorporatie" />
 -->
	</div>
</template>

<script>
import Kaart from './components/kaart';

import gemeenteData from '@/assets/geo/wijk_2019_v2up.json';

import './scss/index.scss'

export default {
	name: 'App',
	mounted: function() {
	},
	data: function() {
		return {
			data: gemeenteData
		}
	},
	components: {
		Kaart
	}
}
</script>